package top.wcpe.allincore.dsl.compiler.ast

import top.wcpe.allincore.dsl.compiler.source.SourcePosition

/**
 * 顶级 `theme { ... }` 文件 AST。
 *
 * 与 [ScreenAst.theme]（screen 块内嵌的主题）共用相同的扁平 token 表语义：
 * - 值类型限 String / Double / Boolean
 * - 整数字面量统一存为 Double
 *
 * scheme 名由文件名推导（去后缀），不再要求文件内声明 `scheme = "..."` 字段。
 * screen 内 `theme { scheme = "Md3Dark" }` 引用该预设时，注册表中的 tokens 会
 * 作为 baseline 与 screen 显式声明字段合并。
 */
data class ThemeFileAst(
    val tokens: LinkedHashMap<String, Any>,
    /** 由文件名推导的 scheme 名（去后缀）。 */
    val schemeName: String,
    val metadata: ThemeMetadataAst? = null,
    override val position: SourcePosition,
) : AstNode {
    /** 每个显式 token 的定义节点；sidecar 不改变既有主构造 ABI。 */
    internal var tokenNodes: LinkedHashMap<String, ThemeTokenAst> = linkedMapOf()
}
